import {Inject, Pipe, PipeTransform} from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'bringozPrice'
})
export class BringozPricePipe implements PipeTransform {
  constructor(@Inject(CurrencyPipe) private currencyPipe: CurrencyPipe, @Inject('splitService') private splitService) {}

  transform(price: number, defaultValue?: string, currencyCode?: string, fullPrecision?: boolean): string {
    if (_.isUndefined(price)) {
      return _.isUndefined(defaultValue) ? '--' : defaultValue;
    }

    const currency = currencyCode || this.splitService.getCurrencyCode();
    if (!fullPrecision) {
      return this.currencyPipe.transform(price, currency);
    }

    const decimals = _.get(price.toString().split('.'), '[1].length', 0);
    return this.currencyPipe.transform(price, currency, undefined, `1.${decimals}-${decimals}`);
  }
}
